import React from "react";
import styled from "styled-components";
import { Organization } from "@domain/organization/organization";
import { useSearchSuggestions } from "@domain/search/hook";
import { SearchDomain } from "@domain/search/searchDomain";
import { useUnmount } from "@utils/hooks";
import { gap } from "@ui/styles/utils";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { MenuRow } from "@ui/components/menus/menuRow";

interface OrganizationSuggestionsProps extends React.HTMLAttributes<HTMLDivElement> {
	search: string;
	onChosen: (organization: Organization) => void;
	onClose?: (organizations: Organization[]) => void;
}
export const OrganizationSuggestions: React.FC<OrganizationSuggestionsProps> = ({
	search,
	onChosen,
	onClose,
	...htmlProps
}) => {
	const { result, totalElements } = useSearchSuggestions(search, SearchDomain.Organization);
	const organizations = result as Organization[];

	useUnmount(([lastResults, close]) => close?.(lastResults), [organizations, onClose]);

	return organizations && totalElements && totalElements > 0 ? (
		<Container {...htmlProps}>
			{organizations.map((organization) =>
				organization ? (
					<MenuRow key={organization.id} onMouseDown={() => onChosen(organization)}>
						<span>{organization.primaryName}</span>
					</MenuRow>
				) : (
					<></>
				)
			)}
		</Container>
	) : null;
};

const Container = styled(RoundedBlock)`
	${gap(5)};
	padding: 10px;
	> * {
		cursor: pointer;
	}
`;
